import { render } from "./Lpn.vue?vue&type=template&id=0c4f226a"
import script from "./Lpn.vue?vue&type=script&lang=js"
export * from "./Lpn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__